import { Component, Input } from '@angular/core';
import { Partners } from './models/partners.interfaces';

@Component({
  selector: 'idp-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent {
  @Input() content: Partners = {} as Partners;

  redirect(link: string) {
    window.open(link, '_blank');
  }
}
